// Хелперы работы с Charon API: конверт {error, data, server_time}, query string, CSV-скачивание.

// WebApi возвращает либо {status_code, message} (HTTP-ошибка), либо тело конверта.
// Успех -> res.data, ошибка -> null.
export function unwrapEnvelope (res) {
  if (res && !res.status_code && !res.error) {
    return res.data !== undefined ? res.data : null
  }
  return null
}

// Текст ошибки конверта/HTTP для снэкбара.
// Конверт ошибки Charon: {error:true, data:"сообщение", code:"..."} — сообщение в data строкой.
export function envelopeError (res) {
  if (!res) return null
  if (res.error) {
    if (res.error.message) return res.error.message
    if (typeof res.data === 'string') return res.data
    if (res.data && res.data.message) return res.data.message
  }
  if (res.message) return res.message
  return null
}

// Объект -> query string. Пропускает null/undefined/''/false, true -> 'true'.
// Ключи snake_case уходят как есть.
export function buildQuery (params) {
  const parts = []
  for (const key in params) {
    const v = params[key]
    if (v === null || v === undefined || v === '' || v === false) continue
    parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(v === true ? 'true' : v))
  }
  return parts.join('&')
}

// Скачивание CSV отчёта: fetch с Bearer (hidden form не подходит — Charon ждёт header).
export async function downloadCsv (path, params, filename) {
  try {
    const url = `${process.env.VUE_APP_CHARON_URL}api/management/${path}?${buildQuery(params)}&format=csv`
    const res = await fetch(url, {
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    })
    if (!res.ok) return false
    const blob = await res.blob()
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(link.href)
    return true
  } catch (e) {
    console.error('downloadCsv error', e)
    return false
  }
}
